import React from "react";

import Link from 'components/Link';
import { ReactComponent as LongArrow } from "images/long_arrow.svg";

const LongArrowButton = (props, ref) => {
	const passThrough = Object.assign({}, props);
	passThrough.className = `${passThrough.className||''} longArrowButton__link ${(props?.align) ? `longArrowButton__align_${props.align}` : ''}`;
	delete passThrough.children;
	return (
		<div className="longArrowButton__root">
			<Link ref={ref} {...passThrough}>
				<div className="longArrowButton__children">
					{props.children}
				</div>
				<div className="longArrowButton__arrow">
					<LongArrow />
				</div>
			</Link>
		</div>
	)
}

export default React.forwardRef(LongArrowButton);